export function updateAllDeliveryMethods(state, { deliveryMethods }) {
  state.all = deliveryMethods;
}
